var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJietou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.38566 1.82353L1.38566 1.5H7.83332V1.82353V5.76471C7.83332 6.59313 8.5049 7.26471 9.33332 7.26471H14.1667H14.5V13.6765H14.1667H6.88567C3.84811 13.6765 1.38567 11.214 1.38567 8.17647L1.38567 7.11936L1.38566 1.82353Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJietou);
export default __webpack_public_path__ + "static/media/jietou.62c992a9d38f3da5d3804684b35a49cd.svg";
export { ForwardRef as ReactComponent };